import { render } from "./ReleaseNotesPage.vue?vue&type=template&id=6f4ce674"
import script from "./ReleaseNotesPage.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__